import axios from "axios";

// import { LOCAL_STORAGE_CONSTANTS } from "constant/general.constants";
// import { clearAuthState } from "store/auth/actions";
// import store from "store";
import { message } from "antd";
import { TOKEN_KEYS } from "utils/constant";

// const { dispatch } = store;

// TODO:: For Refresh token
let isRefreshing = false;
let refreshSubscribers = [];

// Override locally with REACT_APP_API_URL in .env.development.local
// (CRA reads REACT_APP_* vars at build time).
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.styola.com/api/v1";

const Axios = axios.create({
	baseURL: API_BASE_URL,
	// withCredentials: true,
	headers: {
		"Cache-Control": "no-cache",
		"Content-Type": "application/json",
		"Allow-Access-Control-Allow-Origin": "*",
	},
});

const requestHandler = (config) => {
	if (!window.navigator.onLine) {
		Promise.reject("Network Error.");
	}

	let token = localStorage.getItem(TOKEN_KEYS.ACCESS_TOKEN);

	// canChangeRegion: true

	if (!config.headers.Authorization) {
		config.headers.Authorization = token ? `Bearer ${token}` : null;
	}

	// For multipart uploads (e.g. create coupon/sale), drop the default JSON
	// Content-Type so the browser sets multipart/form-data WITH its boundary.
	// Setting "multipart/form-data" by hand omits the boundary and breaks parsing.
	if (config.data instanceof FormData) {
		delete config.headers["Content-Type"];
	}

	return Promise.resolve(config);
};

//request interceptor
Axios.interceptors.request.use(
	async (config) => {
		return requestHandler(config);
	},
	(error) => Promise.reject(error)
);

const errorHandler = async (error) => {
	let errorMessage = "";
	// Case when user closes OTP model
	if (error.code === "ERR_CANCELED") {
		return Promise.reject(error);
	}
	if (!error.response) {
		errorMessage = error.message || "Network error - something went wrong";
		message.error(errorMessage);
	}

	const originalRequest = error.config;
	// A help-desk account whose access an admin removed: sign out at once.
	if (error.response?.status === 401 && error.response?.data?.errors?.[0] === "Your help-desk access has been removed") {
		localStorage.removeItem(TOKEN_KEYS.ACCESS_TOKEN);
		localStorage.removeItem(TOKEN_KEYS.REFRESH_TOKEN);
		message.error({ content: "Your help-desk access has been removed.", key: "errorMessage" });
		window.location.assign("/login?removed=1");
		return Promise.reject(error);
	}
	if (
		error.response &&
		error.response.status === 401 &&
		error.response.data.status === "SESSION_EXPIRED"
	) {
		if (!isRefreshing) {
			// execute on first request
			isRefreshing = true;
			try {
				// const jwtToken = await dispatch(getNewToken());
				const jwtToken = "new Token";
				originalRequest.headers["Authorization"] = `Bearer ${jwtToken}`;
				processQueue(null, jwtToken);

				return Axios(originalRequest);
			} catch (err) {
				processQueue(err, null);
				// return Promise.reject(error);
			} finally {
				isRefreshing = false;
				refreshSubscribers = [];
			}
		} else {
			return new Promise((resolve) => {
				refreshSubscribers.push((token) => {
					originalRequest.headers["Authorization"] = `Bearer ${token}`;
					resolve(Axios(originalRequest));
				});
			});
		}
	}
	if (error.response && error.response.data) {
		let errorResponse = error.response.data;
		if (typeof errorResponse.message === "string")
			errorMessage = errorResponse.message;
		else if (!!errorResponse.errors)
			errorMessage =
				errorResponse.errors?.[0]?.message ||
				errorResponse.errors?.[0]?.msg ||
				errorResponse.errors?.[0];
		else if (typeof errorResponse.message === "object")
			errorMessage = errorResponse.message?.errors?.[0]?.message;
		else if (!!errorResponse?.data?.message)
			errorMessage = errorResponse.data.message;
		else errorMessage = "Something went wrong";

		message.error({
			content: errorMessage,
			key: "errorMessage",
		});

		if (
			["UNAUTHORIZED"].includes(error.response.data.status) ||
			error.response.status === 403
		) {
			// dispatch(clearAuthState());
		}
	}
	return Promise.reject({ errorMessage, ...error });
};

const responseHandler = (response) => {
	return Promise.resolve(response);
};

//response interceptor
Axios.interceptors.response.use(
	(response) => responseHandler(response),
	(error) => errorHandler(error)
);

export default Axios;

function processQueue(error, token = null) {
	refreshSubscribers.forEach((callback) => {
		if (error) {
			callback(null);
		} else {
			callback(token);
		}
	});
}
